/* eslint-disable operator-linebreak */
import React from 'react';
import { useLocation } from 'react-router-dom';

export default function Progressbar() {
  const location = useLocation();
  let progressWidth = 0;
  let firstClass = '';
  let secondClass = '';
  let thirdClass = '';

  if (
    location?.pathname !== '/new-user-details' &&
    location?.pathname !== '/new-user-income' &&
    location?.pathname !== '/new-user-review'
  ) {
    return null;
  }

  if (location?.pathname === '/new-user-details') {
    progressWidth = 18;
    firstClass = 'k-progress-bar-red';
  }

  if (location?.pathname === '/new-user-income') {
    progressWidth = 50;
    firstClass = 'k-progress-bar-red';
    secondClass = 'k-progress-bar-red';
  }

  if (location?.pathname === '/new-user-review') {
    progressWidth = 84;
    firstClass = 'k-progress-bar-red';
    secondClass = 'k-progress-bar-red';
    thirdClass = 'k-progress-bar-red';
  }

  return (
    <div>
      <div
        className="k-progress-bar"
        style={{ width: `${progressWidth}%` }}
        role="progressbar"
        aria-label="Task completion progress"
      />
      <div className="k-progress-bar-links">
        <div className={`k-progress-bar-links-item ${firstClass}`}>About you</div>
        <div className={`k-progress-bar-links-item ${secondClass}`}>Your income</div>
        <div className={`k-progress-bar-links-item ${thirdClass}`}>Review</div>
      </div>
    </div>
  );
}
